module.exports = __webpack_public_path__ + "media/locks/lock-2c3ff495.svg";